import servicesConfig, { CustomAxiosHeaders } from '../config/services'

import { AxiosResponse } from 'axios'
import { FetchRecentlyViewed } from '../types/recently-viewed'
import { TrackEventBody } from '../types/onboarding'
import { requests } from '.'

interface ICompanyIdBody {
  companyId: string
}

interface IStripeMetaData {
  reseller?: string
  tosAcceptedBy?: string
  ppAcceptedBy?: string
  tosAcceptedDate?: string
  ppAcceptedDate?: string
  tosVersion?: string
  ppVersion?: string
  niche?: string
  clientCount?: string
  previousProduct?: string
  onboardingKickoffEvent?: string
}

interface IUpdateStripeCustomer extends ICompanyIdBody {
  metaData: IStripeMetaData
}

interface IUpdateContactInfo extends ICompanyIdBody {
  clientCount: string
  niche: string
  isReselling: string
  previousProduct?: string
  website?: string
}

interface IRewardEnumParams {
  companyId: string
  dateAdded: string
}

// Configure request setup
const serviceName = 'OnboardingService'
const host = servicesConfig.Onboarding as string
const opts: CustomAxiosHeaders = { host, serviceName, useNewToken: true }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

// Helper function to handle response
const responseBody = (res: AxiosResponse) => res.data

// Define service object with methods
const OnboardingService = {
  createTosLogs: (body: any) => 
    request().post('/tos', body).then(responseBody),
    
  recentlyViewed: (params: FetchRecentlyViewed) => 
    request().get(`/${params.locationId}/recently-visited?skip=${params.skip}&limit=${params.limit}`).then(responseBody),
    
  verifyStatus: (companyId: string) => 
    request().get(`/verify/status?companyId=${companyId}`).then(responseBody),
    
  onboardingTagTaskScheduler: (body: ICompanyIdBody) => 
    request().post('/tags/task-scheduler', body).then(responseBody),
    
  getStripeSubscriptionList: (body: ICompanyIdBody, stripeCustomerId: string) => 
    request().post(`/stripe/list-subscriptions/${stripeCustomerId}`, body).then(responseBody),
    
  updateStripeCustomer: (body: IUpdateStripeCustomer) => 
    request().put(`/stripe/customer`, body).then(responseBody),
    
  updateContactInfo: (body: IUpdateContactInfo) => 
    request().put(`/info/contacts`, body).then(responseBody),
    
  getVersion: (params: ICompanyIdBody) => 
    request().get(`/version?companyId=${params.companyId}`).then(responseBody),
    
  getInfo: (params: ICompanyIdBody) => 
    request().get(`/version/${params.companyId}`).then(responseBody),
    
  trackEvents: (body: TrackEventBody) => 
    request().post('/track/events', body).then(responseBody),

  getValuePropProductIds: (valuePropId: string, params: ICompanyIdBody) =>
    request().get(`/value-props/${valuePropId}?companyId=${params.companyId}`).then(responseBody),

  getRewardEnum: (params: IRewardEnumParams) => 
    request().get(`/version/reward-enum/${params.companyId}?dateAdded=${params.dateAdded}`).then(responseBody),
}

export default OnboardingService

